import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@mui/material';
import { red, green } from '@mui/material/colors';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import MarkEmailReadRoundedIcon from '@mui/icons-material/MarkEmailReadRounded';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { useJobsContext } from '../JobsContext';

export function Emails({ emailList, setEmailList, emailOption, setEmailOption }) {
  const { selectedJobs: jobs } = useJobsContext();
  const [newEmail, setNewEmail] = useState('');

  useEffect(() => {
    const rawList = jobs.map((j) => j?.config?.emailConfig?.emailContacts);
    const emails = [...new Set([...rawList.flat(1)])];
    setEmailList(emails);
  }, [jobs, setEmailList]);

  function DisplayEmails() {
    if (emailList.length === 0) return <>No emails to show</>;

    return emailList.map((email, index) => (
      <Box key={makeKey(index)}>
        <ListItem key={makeKey(index)} sx={{ px: 6 }}>
          <ListItemIcon key={makeKey(index)} sx={{ minWidth: '2em' }}>
            <MarkEmailReadRoundedIcon key={makeKey(index)} fontSize="small" />
          </ListItemIcon>
          <ListItemText
            key={makeKey(index)}
            primary={email}
            sx={{ paddingRight: 3 }}
          />
          <IconButton
            key={makeKey(index)}
            sx={{ p: 0 }}
            onClick={() => removeEmail(email)}
          >
            <RemoveCircleOutlineRoundedIcon
              key={makeKey(index)}
              sx={{ color: red[500] }}
            />
          </IconButton>
        </ListItem>
        <Divider key={makeKey()} variant="fullwidth" component="li" />
      </Box>
    ));
  }

  function validateEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isGoodFormat = regex.test(email);
    if (!isGoodFormat) {
      alert('ERROR: the input email is invalid');
      return false;
    }

    const isRepeated = emailList.includes(email);
    if (isRepeated) {
      alert('WARNING: email already in use');
      return false;
    }

    return true;
  }

  function addEmail(email) {
    const isValid = validateEmail(email);
    if (!isValid) return;

    const newUniqueEmails = [...new Set([...emailList, email])];
    setEmailList(newUniqueEmails.sort());
  }

  function removeEmail(email) {
    setEmailList(emailList.filter((e) => e !== email));
  }

  const handleChange = (event) => setNewEmail(event.target.value);

  const handleOptionChange = (event) => setEmailOption(event.target.value);

  const makeKey = (input = '0') => `email-${input}-${Math.random() * 100}`;

  return (
    <Box key="emails-manager-container" sx={{ minWidth: '30em' }}>
      <List key="jobs-emails-list">
        {jobs.map((job) => (
          <ListItem key={makeKey()} sx={{ px: 6 }}>
            <ListItemIcon sx={{ minWidth: 30 }} key={makeKey()}>
              <WorkOutlineIcon key={makeKey()} fontSize="small" />
            </ListItemIcon>
            <ListItemText key={makeKey()} primary={`${job.jobName}`} />
          </ListItem>
        ))}
      </List>
      <Box display="flex" alignItems="center" gap={2}>
        <TextField
          key="email-input"
          fullWidth
          label="add email"
          name="Jobs"
          placeholder="joe@email.com,"
          variant="outlined"
          value={newEmail}
          onChange={handleChange}
          focused
          sx={{ marginLeft: 2 }}
        />
        <IconButton sx={{ p: 0 }} onClick={() => addEmail(newEmail)}>
          <AddCircleRoundedIcon sx={{ color: green[500] }} fontSize="large" />
        </IconButton>
      </Box>
      <Card sx={{ boxShadow: 0 }}>
        <CardHeader title="Emails" sx={{ paddingBottom: 0 }} />
        <CardContent>
          <List key="emails-list" sx={{ py: 0 }}>
            <DisplayEmails />
          </List>
        </CardContent>
      </Card>
      <Box sx={{ mt: 2 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <span>Send success email:</span>
          <RadioGroup
            aria-label="sendSuccessEmails"
            name="sendSuccessEmails"
            value={emailOption}
            onChange={handleOptionChange}
            row
          >
            <FormControlLabel value="trueAll" control={<Radio />} label="Yes" />
            <FormControlLabel value="falseAll" control={<Radio />} label="No" />
            <FormControlLabel value="keepAsIs" control={<Radio />} label="Keep current values" />
          </RadioGroup>
        </Box>
      </Box>
    </Box>
  );
}
